import { IdentifiedFieldIssue } from '../IFITrackerContext/types'
import { getReport } from './getReport'

export function getPayItems(record?: IdentifiedFieldIssue | null) {
  if (!record) return []
  return getReport(record)?.payItemNoGeometries ?? []
}
